export const simpleModalStyle = {
  'maxHeight': '90vh',
  'maxWidth': '600px',
  'height': 'auto',
  'width': '100%',
  '& > div:nth-child(2)': {
    position: 'relative',
  },
};

export const modalBodyStyle = {
  minHeight: '100px',
  paddingBottom: '40px',
};

export const fieldStyle = {
  paddingTop: '20px',
  width: '100%',
};
